import React from "react";

import Framework from "@beardeddevops/react.framework";
import {Parts, Types} from "components";

import ObjectOverride from "components/ObjectOverride";
import WarningAlert from "../Elements/DispositionPendingWarningAlert";


/**
 *  @property {Products_Ioi_Inspections_Object} state
 *  @property {object} model
 *  @property {Products_Ioi_Inspections_Properties} model.properties
 *  @property {Products_Ioi_Inspections_Is} model.is
 *  @property {Products_Ioi_Inspections_Has} model.has
 */
export default class IoiInspection extends ObjectOverride {
	constructor(props) {
		super(props, Types.Products_Ioi_Inspections._name);
		this.redirect = props.hasModal ? null : '/products/ioi_inspections';
	}


	// componentDidMount() {
	// 	super.componentDidMount();
	// 	console.log('this in mounting', this);
	// 	if(this.state.id) {
	// 		if(this.props.receiveCurrentIoiId) {
	// 			this.props.receiveCurrentIoiId(this.state.id);
	// 		}
	// 	}
	// }

	form = () => {
		/** @type {Products_Ioi_Inspections_Properties} properties */
		let properties = this.model.properties;
		/** @type {Products_Ioi_Inspections_Object} object */
		let object = this.state;
		let {loading} = this.state;

		return (
			<div>
				<fieldset>
					<div className="row">
						<div className="col-md">
							{object.is_open &&
								<WarningAlert
									hideButton={true}
									warningName={'Inspection Currently Paused'}
									warningMessage={'Inspection is currently open and in a paused state. Return to the IOI inspection by clicking IOI Mode, ' +
										'and then complete the inspection to populate the table with items below.'}
								/>}
							<h4 className="section-title">Inspection</h4>

							<div className="form-group">
								<Framework.Elements.TextField
									value={object.inspector}
									error={object.inspector_error}
									property={properties.inspector}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>

							<Parts.SelectLocation
								object={object}
								properties={properties}
								shouldLoad={this.state.loaded}
								onSelectUpdate={this.handleSelectPropertyUpdate}
								locations={this.props.locations}
								states={this.props.states}
								filter={this.filterLocationOptions}
							/>

							<div className="form-group">
								<div className="row">
									<div className="col-6">
										<div className="form-group">
											<Framework.Elements.DateTime
												label="Start Date"
												property={properties.date_start}
												value={object.date_start}
												error={object.date_start_error}
												update={this.handleTextFieldPropertyUpdate}
												disabled={false}
											/>
										</div>
									</div>
									<div className="col-6">
										<div className="form-group">
											<Framework.Elements.DateTime
												label="End Date"
												property={properties.date_end}
												value={object.date_end}
												error={object.date_end_error}
												update={this.handleTextFieldPropertyUpdate}
												disabled={false}
											/>
										</div>
									</div>
								</div>
							</div>

							<div className="form-group">
								<Framework.Elements.TextField
									label="Notes"
									property={properties.notes}
									value={object.notes}
									error={object.notes_error}
									update={this.handleTextFieldPropertyUpdate}
									multiline={4}
								/>
							</div>
						</div>
					</div>
				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	};
}
